export const muiPublicLicenseKey =
  "f8aeb95951db326048e6b79ef9824d1aTz05NTcxMixFPTE3NTQ1OTMyNDYwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
